import React from 'react'
import { AlignLeft, AlignCenter, AlignRight, AlignJustify } from 'lucide-react'

interface AlignmentInputProps {
	value: string
	onChange: (value: string) => void
}

export default function AlignmentInput({ value, onChange }: AlignmentInputProps) {
	const options = [
		{ value: 'left', icon: AlignLeft, label: 'Esquerda' },
		{ value: 'center', icon: AlignCenter, label: 'Centro' },
		{ value: 'right', icon: AlignRight, label: 'Direita' },
		{ value: 'justify', icon: AlignJustify, label: 'Justificado' }
	]

	return (
		<div className="flex space-x-1 flex-wrap">
			{options.map((option) => {
				const Icon = option.icon
				const isActive = value === option.value
				
				return (
					<button
						key={option.value}
						type="button"
						onClick={() => onChange(option.value)}
						className={`
							flex-1 px-3 py-2 text-xs border rounded-md transition-colors
							${isActive 
								? 'bg-gradient-primary text-white border-primary-500' 
								: 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
							}
						`}
						title={option.label}
					>
						<Icon className="w-4 h-4 mx-auto" />
					</button>
				)
			})}
		</div>
	)
}
